import { useMutation } from '@tanstack/react-query';
import { patchProcessedTimesheetEntry } from '../Services/ProcessedTimesheetService';

const usePatchProcessedTimeSheetEntry = (options = {}) =>
    useMutation(patchProcessedTimesheetEntry, options);

export default usePatchProcessedTimeSheetEntry;
